<template>
    <div id='login' :class="'login mainheader-' + $mode">
        <form class="" method="POST" action='' @submit.prevent="handleSubmit" >
            <div id='login-webbook' v-html="this.$parent.webbook.login"></div>
            <div id='login-webbook-notext' v-if="!this.$parent.webbook.login">
                <h3>Bitte loggen Sie sich ein!</h3>
            </div>
            <div>
                <label for="email-field">
                    {{ $mode == 'ms' ? 'Benutzer (Lizenznummer)' :  'E-Mail' }}
                </label>
                <div>
                    <input
                        :type="$mode == 'ms' ? 'number' :  'email'"
                        v-model="email"
                        id="email-field"
                        name='user_email'
                        value=''
                        :placeholder="$mode == 'ms' ? 'Lizenznummer' :  'E-Mail-Adresse'">
                </div>
            </div> <!-- end email -->
            <div>
                <label for="passwd-field">
                    Passwort
                </label>
                <div>
                    <input
                        id="passwd-field"
                        v-model="password"
                        type="password"
                        name='user_passwd'
                        value=''
                        placeholder="Passwort">
                </div>
            </div> <!-- end passwd -->

            <div v-if="$mode!='ms'" id='login-requestpassword'>
                <a :href="url + 'redefining'">Passwort vergessen?</a>
            </div>

            <div v-if="!processing" class="">
                <input type="submit" class="btn" name='dologin' value='Anmelden' />
            </div>
            <div v-if="processing">
                <font-awesome-icon icon="spinner" spin/>
            </div>

        </form>
        <div  v-if="$mode!='ms'" id='login-register'>
            <h3>Noch kein Konto?</h3>
            <a :href="url + 'registration'">Bitte registrieren Sie sich hier!</a>
        </div>
    </div>    
</template>

<script>
import MS_CONST from '../msclasses/msconst.js'

export default {
    name: "Login",
    props: {        
    },
    data() {
        return {
            email: '',
            password: '',
            processing: false,
            url: MS_CONST.SHOP_URL
        };
    },    
    mounted() {
        require('../assets/css/Login.css')
        try { require('../assets/css/' + this.$mode + '/Login.css') } catch (e) {}
    },
    created() {
        this.$parent.setBacklink('');
    },
    methods: {
        handleSubmit() {
            var self = this;
            this.$log.debug('form: ' + this.email + ' / ' + this.password);
            this.processing = true;

            this.$ms.apiLogin(this, this.email, this.password, function(token) {
                self.$parent.logintoken = token;
            });
        }       
    }
};
</script>

<style/>
